import React from 'react';
import { Routes } from './../Core/Constants';
import { AppStore } from './../Core/AppStore'


export default class AddToCartModal extends React.Component {
	constructor(props) {
		super(props);
	}
	state = {
		product: null
	}

	componentDidMount = () => {

		AppStore.on('Cart.AddingProduct', (product) => {
			this.setState({
				product: product
			});
		});
	}
	

	handleClose = (e) => {
		e.preventDefault();
		this.setState({ product: null });
	}

	render = () => {
		let product = this.state.product;
		if (!product) return null;
		var T = window.Texts.catalogue;
		return (
			<div className="add-2-cart-modal" style={{ display: 'block'}}>
				<div className="modal-cover">
					<div className="modal-content">
						<div className="header">
							<h5>{T.goodsAdd}:</h5>
							<a className="close" href="#" onClick={(e) => this.handleClose(e)}></a>
						</div>
						<div className="item-in-cart">
							<div className="thumb"><img src={product.picture} /></div>
							<a href={product.url}><u>{product.name}</u></a>
							<span><strong>{product.price}</strong> {T.withTax}</span>
						</div>
						<div className="button">
							<a className="close" href="#" onClick={(e) => this.handleClose(e)}><span>{T.contin}</span></a>
							<a className="btn iconed icon-continue" style={{ padding: '0px 10px'}} href={Routes.Cart}><span>{T.toCart}</span></a>
						</div>
					</div>
				</div>
			</div>);
	}
}

//inicializace
var element = document.getElementById("app-cart-modal");
if (element) {
	ReactDOM.render(<AddToCartModal />, element);
}




